export const generateMqttRandomClientId = () => `_${Math.floor(Math.random() * 10000000)}`
